import { render, staticRenderFns } from "./alarmLimitsFast.vue?vue&type=template&id=efc08c7c&"
import script from "./alarmLimitsFast.vue?vue&type=script&lang=js&"
export * from "./alarmLimitsFast.vue?vue&type=script&lang=js&"
import style0 from "./alarmLimitsFast.vue?vue&type=style&index=0&id=efc08c7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports